// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    /* Store Custom Code - Start */
    accordion: {
        padding: {
            horizontal: pxToRemArray([16, 25]),
            vertical: pxToRemArray([25]),
        },
    },
    common: {
        contentRadius: pxToRem(0),
    },
    header: {
        padding: pxToRemArray([21, null, 30]),
    },
    menu: {
        panel: {
            rowPadding: pxToRem(16, 20),
            rowWrapperPadding: pxToRem(0, 0),
        },
    },
    /* Store Custom Code - End */
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
    },
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    /* Store Custom Code - Start */
    typography: {
        fontFamily: {
            title: `"Oxanium", Arial, Helvetica, sans-serif`,
            base: `"Figtree", Arial, Helvetica, sans-serif`,
        },
    },
    /* Store Custom Code - End */
};

export default design;
